// JsFromRoutes CacheKey 3b378c5f012ac98f849840daf6b5d32d
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  delete: /* #__PURE__ */ definePathHelper('get', '/transfers/:public_id/delete'),
  create: /* #__PURE__ */ definePathHelper('post', '/transfers'),
  new: /* #__PURE__ */ definePathHelper('get', '/transfers/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/transfers/:public_id/edit'),
  update: /* #__PURE__ */ definePathHelper('patch', '/transfers/:public_id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/transfers/:public_id'),
}
